import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Sale } from './sale';
import { SaleItem } from './sale-item';
import { Configuration } from '../../app.constants';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { Piece } from '../inventory/piece';
import { Branch } from '../accounting/branch';
import { User } from '../../shared/classes/user';
import { BackOrder } from './backorder';
import { BackorderItem } from './backorder-item';
import { DebitNote } from './debit-note';

@Injectable()
export class SalesService {
    _refundsUrl = this._configuration.apiUrl + '/v2/refund';
    _backorderUrl = this._configuration.apiUrl + '/v2/backorder';
    _debitnotesUrl = this._configuration.apiUrl + '/v2/debitnote';
    _refundsItemsUrl = this._configuration.apiUrl + '/v2/refund/items';
    _backorderItemsUrl = this._configuration.apiUrl + '/v2/backorder/items';
    _debitnoteItemsUrl = this._configuration.apiUrl + '/v2/debitnote/items';
    _usersUrl = this._configuration.apiUrl + '/v2/user';
    _salesApiUrl = this._configuration.apiUrl + '/v2/sales';
    _salesAndInvoiceApiUrl = this._configuration.apiUrl + '/v2/salesandinvoice';
    _salesItemsApiUrl = this._configuration.apiUrl + '/v2/sales/items';
    _colorUrl = this._configuration.apiUrl + '/v2/color';
    _customerUrl = this._configuration.apiUrl + '/v2/customer';

    constructor(private _http: Http,
        private _configuration: Configuration,
        public _authService: AuthenticationService) { }


    getSales(): Observable<Sale[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        // This apparently doesn't do anything?
        //s.append('list', 'true');

        return this._http.get(this._salesApiUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['salesorders'] == null || !Array.isArray(body['salesorders']))
                    return [];
                return body['salesorders'];
            }
        );
    }

    getSalesHistory(fromDate, toDate): Observable<any[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('from_date', fromDate);
        s.append('to_date', toDate);

        return this._http.get(this._salesApiUrl + '/history', { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['saleshistory'] == null || !Array.isArray(body['saleshistory']))
                    return [];
                return body['saleshistory'];
            }
        );
    }

    getDebitNotes(): Observable<DebitNote[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('list', 'true');

        return this._http.get(this._debitnotesUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['debitnotes'] == null || !Array.isArray(body['debitnotes']))
                    return [];
                return body['debitnotes'];
            }
        );
    }

    getRefunds(): Observable<Sale[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('list', 'true');

        return this._http.get(this._refundsUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['refundorders'] == null || !Array.isArray(body['refundorders']))
                    return [];
                return body['refundorders'];
            }
        );
    }

    getBackOrders(): Observable<BackOrder[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('list', 'true');

        return this._http.get(this._backorderUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['backorders'] == null || !Array.isArray(body['backorders']))
                    return [];
                return body['backorders'];
            }
        );
    }

    getUsersPerBranch(branch_id: string): Observable<User[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('branchUsers', 'true');
        s.append('branch_id', branch_id);

        return this._http.get(this._usersUrl, { headers: h, search: s }).map(
            (response: Response) => {
                let body = response.json();
                if (body['users'] == null || !Array.isArray(body['users'])) {
                    return [];
                }
                return body['users'];
            })

    }

    getOneSale(id: string): Observable<Sale> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id);

        return this._http.get(this._salesApiUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                let final: Sale;

                if (body['salesorders'] == null || !Array.isArray(body['salesorders'])) {
                    final = new Sale();
                } else {
                    final = body['salesorders'][0];
                }

                //Adjust dates
                final.order_date = final.order_date.substring(0, 10);
                final.delivery_date = final.delivery_date.substring(0, 10)


                return final;
            }
        );
    }

    getOneSaleByOrderNumber(order_number: string): Observable<Sale> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('order_number', order_number);

        return this._http.get(this._salesApiUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                let final: Sale;

                if (body['salesorders'] == null || !Array.isArray(body['salesorders'])) {
                    final = new Sale();
                } else {
                    final = body['salesorders'][0];
                }

                //Adjust dates
                final.order_date = final.order_date.substring(0, 10);
                final.delivery_date = final.delivery_date.substring(0, 10)


                return final;
            }
        );
    }

    getOneDebitNote(id: string): Observable<DebitNote> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id);

        return this._http.get(this._debitnotesUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                let final: DebitNote;

                if (body['debitnotes'] == null || !Array.isArray(body['debitnotes'])) {
                    final = new DebitNote();
                } else {
                    final = body['debitnotes'][0];
                }

                //Adjust dates
                final.order_date = final.order_date.substring(0, 10);
                final.delivery_date = final.delivery_date.substring(0, 10)


                return final;
            }
        );
    }

    getOneBackOrder(id: string): Observable<Sale> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id);

        return this._http.get(this._backorderUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                let final: Sale;

                if (body['backorders'] == null || !Array.isArray(body['backorders'])) {
                    final = new Sale();
                } else {
                    final = body['backorders'][0];
                }

                //Adjust dates
                final.order_date = final.order_date.substring(0, 10);
                final.delivery_date = final.delivery_date.substring(0, 10)


                return final;
            }
        );
    }

    getOneRefund(id: string): Observable<Sale> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id);

        return this._http.get(this._refundsUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                let final: Sale;

                if (body['refundorders'] == null || !Array.isArray(body['refundorders'])) {
                    final = new Sale();
                } else {
                    final = body['refundorders'][0];
                }

                //Adjust dates
                final.order_date = final.order_date.substring(0, 10);
                final.delivery_date = final.delivery_date.substring(0, 10)


                return final;
            }
        );
    }

    deleteOneSale(id: string) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id);

        return this._http.delete(this._salesAndInvoiceApiUrl, { headers: h, search: s }).map(response => Object.assign({ id: id }, response.json()));
    }

    deleteOneDebitNote(id: string) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id);

        return this._http.delete(this._debitnotesUrl, { headers: h, search: s }).map(response => Object.assign({ id: id }, response.json()));
    }

    deleteOneSaleByOrderNumber(order_number: string) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('order_number', order_number);

        return this._http.delete(this._salesApiUrl, { headers: h, search: s }).map(response => Object.assign({ order_number: order_number }, response.json()));
    }

    deleteOneRefund(id: string) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id);

        return this._http.delete(this._refundsUrl, { headers: h, search: s }).map(response => Object.assign({ id: id }, response.json()));
    }

    deleteOneBackorder(id: string) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id);

        return this._http.delete(this._backorderUrl, { headers: h, search: s }).map(response => Object.assign({ id: id }, response.json()));
    }

    getSaleItems(sales_order_id: string): Observable<Piece[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('sales_order_id', sales_order_id);

        return this._http.get(this._salesItemsApiUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['items'] == null || !Array.isArray(body['items']))
                    return [];
                return body['items'];
            }
        );
    }

    getItemsNotPrepared(sales_order_id: string): Observable<Piece[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('sales_order_id', sales_order_id);

        return this._http.get(this._salesApiUrl + '/itemsnotprepared', { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['items'] == null || !Array.isArray(body['items']))
                    return [];
                return body['items'];
            }
        );
    }

    getDebitNoteItems(debit_note_id: string): Observable<any[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('debit_note_id', debit_note_id);

        return this._http.get(this._debitnoteItemsUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['items'] == null || !Array.isArray(body['items']))
                    return [];
                return body['items'];
            }
        );
    }

    getBackOrderItems(back_order_id: string): Observable<BackorderItem[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('back_order_id', back_order_id);

        return this._http.get(this._backorderItemsUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['items'] == null || !Array.isArray(body['items']))
                    return [];
                return body['items'];
            }
        );
    }

    getRefundItems(refund_order_id: string): Observable<Piece[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('refund_order_id', refund_order_id);

        return this._http.get(this._refundsItemsUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['items'] == null || !Array.isArray(body['items']))
                    return [];
                return body['items'];
            }
        );
    }

    createSale(sale: Sale): Observable<any> {
        let h: Headers = this._authService.getHeaders();

        return this._http.post(this._salesApiUrl, sale, { headers: h, search: null }).map(response => response.json());
    }

    createDebitNote(debitnote: DebitNote): Observable<any> {
        let h: Headers = this._authService.getHeaders();

        console.log("type: " + debitnote.type);

        return this._http.post(this._debitnotesUrl, debitnote, { headers: h, search: null }).map(response => response.json());
    }

    createBackOrder(sale: BackOrder): Observable<any> {
        let h: Headers = this._authService.getHeaders();

        return this._http.post(this._backorderUrl, sale, { headers: h, search: null }).map(response => response.json());
    }

    createRefund(sale: Sale): Observable<any> {
        let h: Headers = this._authService.getHeaders();

        return this._http.post(this._refundsUrl, sale, { headers: h, search: null }).map(response => response.json());
    }

    updateSale(id: number, sale: Sale): Observable<any> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id + '');

        return this._http.put(this._salesApiUrl, sale, { headers: h, search: s }).map(response => response.json());
    }

    updateSaleCustomInvoiceNumber(id: number, invoiceNumber: string) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id + '');
        s.append('invoiceNumber', invoiceNumber);

        return this._http.put(this._salesApiUrl + '/custominvoicenumber', undefined, { headers: h, search: s }).map(response => response.json());
    }

    setItemsNotPrepared(id: number, itemsNotPrepared: Piece[]) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id + '');

        return this._http.post(this._salesApiUrl + '/itemsnotprepared', itemsNotPrepared, { headers: h, search: s }).map(response => response.json());
    }

    generateInvoiceNumber(id: number, sale: Sale): Observable<any> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id + '');
        s.append('branch_id', sale.branch_id + '');
        s.append('invoice', 'true');

        return this._http.put(this._salesApiUrl, {}, { headers: h, search: s }).map(response => response.json());
    }

    updateDebitNote(id: number, debitnote: DebitNote): Observable<any> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id + '');

        return this._http.put(this._debitnotesUrl, debitnote, { headers: h, search: s }).map(response => response.json());
    }

    updateBackOrder(id: number, sale: BackOrder): Observable<any> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id + '');

        return this._http.put(this._backorderUrl, sale, { headers: h, search: s }).map(response => response.json());
    }

    updateRefund(id: number, sale: Sale): Observable<any> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id + '');

        return this._http.put(this._refundsUrl, sale, { headers: h, search: s }).map(response => response.json());
    }

    getCustomerPrefixes(): Observable<any[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('short', 'true');

        console.log(this._authService.getUser());

        return this._http.get(this._customerUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['customers'] == null || !Array.isArray(body['customers']))
                    return [];
                return body['customers'];
            }
        );
    }

    getStatuses(): Observable<string[]> {
        return Observable.of(['DRAFT', 'PROCCESSED', 'DONE', 'CANCELED']);
    }

    getTypes(): Observable<string[]> {
        return Observable.of(['SALE', 'B2B']);
    }

    getDesignColors(supplier_id?, supplier_names?): Observable<string[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('minify', 'true');
        if (supplier_id) s.append('supplier_id', supplier_id);
        if (supplier_names != null) s.append('supplier_names', supplier_names);

        return this._http.get(this._colorUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();

                if (body['colors'] == null || !Array.isArray(body['colors']))
                    return [];

                return (body['colors']).sort((a, b) => {
                    return (a['design_name'] != b['design_name']) ?
                        ((a['design_name'] > b['design_name']) ? 1 : -1) :
                        ((a['color_name'] > b['color_name']) ? 1 : -1);
                });
            }
        );
    }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/sales/sales.service.ts